module.exports = __webpack_public_path__ + "static/media/whatsapp_white.909e7bfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whatsapp_white.png
// module id = 160
// module chunks = 0